export default __webpack_public_path__ + "static/media/chimeron_maly.6c89e62d.png";